import InstrumentsPanel from "views/InstrumentsPanel/InstrumentsPanel";
import UmidityScreen from "views/UmidityScreen/UmidityScreen";
import StockMaterials from "views/StockMaterials/StockMaterials";
import FamiliesAndFormulas from "views/FamiliesAndFormulas/FamiliesAndFormulas";
import GeneralRegister from "views/GeneralRegister/GeneralRegister";
import ShipmentReport from "views/ShipmentReport/ShipmentReport";
import ControllerSettings from "views/ControllerSettings/ControllerSettings";
import AutomationStatus from "views/AutomationStatus/AutomationStatus";
import Login from "views/Login/Login";
import Schedule from "views/Schedule/Schedule";
import ProcessesManagement from "views/ProcessesManagement/ProcessesManagement";
import Requests from "views/Requests/Requests";
import UserManagement from "views/UserManagement/UserManagement";
import { SCREENS, isScreenVisible } from "screens.js";

// Screen key -> React component. Metadata (path/name/icon/hidden) lives in
// screens.js; this map is the only place that ties a screen to its component.
const COMPONENTS = {
  instruments_panel: InstrumentsPanel,
  processes_management: ProcessesManagement,
  schedule: Schedule,
  shipment_report: ShipmentReport,
  umidity: UmidityScreen,
  stock_materials: StockMaterials,
  families_formulas: FamiliesAndFormulas,
  general_registers: GeneralRegister,
  automation_status: AutomationStatus,
  controller_settings: ControllerSettings,
  requests: Requests,
  user_management: UserManagement,
};

const allScreenRoutes = SCREENS.map(screen => ({
  path: screen.path,
  name: screen.name,
  icon: screen.icon,
  component: COMPONENTS[screen.key],
  layout: "/admin",
  isHidden: Boolean(screen.hidden),
}));

const loginRoute = {
  path: "/login",
  name: "Login",
  mini: "L",
  component: Login,
  isHidden: true,
  layout: "/auth",
};

const getRoutes = (userRole, isScheduleEnabled, screenOverrides) => {
  const visibleRoutes = SCREENS
    .filter(screen => isScreenVisible(userRole, screen.key, screenOverrides))
    .filter(screen => isScheduleEnabled || screen.key !== "schedule")
    .map(screen => allScreenRoutes.find(route => route.path === screen.path));

  return [...visibleRoutes, loginRoute];
};

const routes = (userRole, isScheduleEnabled, screenOverrides) => getRoutes(userRole, isScheduleEnabled, screenOverrides);

export default routes;
